import { render, staticRenderFns } from "./BindMobile.vue?vue&type=template&id=1738dcd7&scoped=true&"
import script from "./BindMobile.vue?vue&type=script&lang=js&"
export * from "./BindMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1738dcd7",
  null
  
)

export default component.exports